import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./MobileNav.css";
import ToolsImg from "./../../Images/tools-menu.png";
import UtilitiImg from "./../../Images/utilities-menu.png";
import OtherImg from "./../../Images/others-menu.png";
import PartnetImg from "./../../Images/partner-with-us-menu.png";
import kambalalogin from "./../../Images/kambala-login.png";
import backofficeImg from "./../../Images/backoffice_login.png";
import brokcal from '../../Images/calculator-brok.png';
import { useNavigate, useLocation } from "react-router-dom";
import TrackApi from "../Activity_Track/TrackApi";
import { useCookies } from "react-cookie";

function MobileNav({ closeNav }) {
    const location = useLocation();
    const [cookies, setCookie] = useCookies(['LeadId']);

    let navigate = useNavigate();
    const routeChange = () => {
        let path = `/FoxTrader`;
        window.open(path, '_blank')
    };
    const routeChangeTrade = () => {
        let path = `/AlgoTrading`;
        window.open(path, '_blank')
    };
    const routeChangeTradeRadar = () => {
        let path = `/TradeRadar`;
        window.open(path, '_blank')
    };
    const routeChangeQuantman = () => {
        // let path = `/Quantman`;
        let path = `/SmartOptions`;
        window.open(path, '_blank')
    };
    const routeChangeBrokarage = () => {
        let path = `/Brokerage-calculator`;
        window.open(path, '_self')
    };
    const routeChangeEmi = () => {
        let path = `/Emi-calculator`;
        window.open(path, '_self')
    };
    const routeChangeFd = () => {
        let path = `/Fd-calculator`;
        window.open(path, '_self')
    };
    const routeChangeElss = () => {
        let path = `/Elss-calculator`;
        window.open(path, '_self')
    };
    const funPlatforms = () => {
        //console.log("logs:" + JSON.stringify(location));
        let widthWindow = window.matchMedia("(max-width: 550px)")
        if (widthWindow.matches) {
            if (location.pathname == "/") {
                window.scrollTo({
                    top: 6800,
                    behavior: 'smooth',
                });
            }
            else if(location.pathname == "/market/stocks") {
                let path = `./`;
                navigate(path, { state: { plan: "platforms" } });
                window.scrollTo({
                    top: 6800,
                    behavior: 'smooth',
                });
            }
            else {
                let path = `./`;
                navigate(path, { state: { plan: "platforms" } });
            }
        } else {
            if (location.pathname == "/") {
                window.scrollTo({
                    top: 3660,
                    behavior: 'smooth',
                });
            }
            else {
                let path = `./`;
                navigate(path, { state: { plan: "platforms" } });
            }
        }


    };
    const trackData=(id,url,pagename)=>{
        const payloadData={
          "RelatedProspectId":id,
          "ActivityNote": `${pagename} page visit`,
          "mx_Custom_1": pagename,
          "mx_Custom_2": "",
          "mx_CustomObject_81":url
         }
         TrackApi(payloadData);
    }
    const Backoffice = (url, pagename) => {
        if (cookies && cookies.RelatedProspectId) {
            trackData(cookies.RelatedProspectId, url, pagename);
        }
    }
    return (
        <>
            <div id="overlay" onClick={() => closeNav(false)}>
                <Container>
                    <Row>
                        <Col>
                            <div className="mobileNav-menu">
                                <div className="showMenuNav">
                                    <ul>
                                        <li>
                                            <a href="/About">About Us</a>
                                        </li>
                                        <li>
                                            <a href="/Products">Products</a>
                                        </li>
                                        <li>
                                            <a href="/market/stocks">Markets</a>
                                        </li>
                                        <li>
                                            <a href="/Pricing">Pricing</a>
                                        </li>
                                        <li>
                                            <a href="https://support.moneysukh.com/" target="_blank">Support</a>
                                        </li>
                                    </ul>
                                </div>
                                
                                <div className="main-navbar-alpha">
                                    <ul>
                                        <li>
                                            <img
                                                className="img-fluid"
                                                src={ToolsImg}
                                                alt="ToolsImg"
                                            />
                                            <h4>Tool</h4>
                                        </li>
                                        <li>
                                            <a onClick={routeChange}>Intraday Live Charts</a>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeTrade}>Algo Trading</a>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeTradeRadar}>Trade Radar</a>
                                        </li>
                                        <li>
                                            {/* <a onClick={routeChangeQuantman}>Quantman</a> */}
                                            <a onClick={routeChangeQuantman}>Smart Options</a>
                                        </li>

                                    </ul>
                                    <ul>
                                        <li>
                                            <img
                                                className="img-fluid"
                                                src={UtilitiImg}
                                                alt="UtilitiImg"
                                            />
                                            <h4>Utilities</h4>
                                        </li>
                                        <li>
                                            <a href="https://learn.moneysukh.com/category/blogs/" target="_blank">Market Blogs</a>
                                        </li>
                                        <li>
                                            <a href="/DialNTrade">Dial n Trade</a>
                                        </li>
                                        <li>
                                            <a href="https://learn.moneysukh.com/glossary-a/" target="_blank">Glossary</a>
                                        </li>
                                        <li>
                                            <a href="https://support.moneysukh.com/" target="_blank">Help & Support</a>
                                        </li>


                                    </ul>
                                    <ul className="paddL5">
                                        <li>
                                            <img
                                                className="img-fluid"
                                                src={OtherImg}
                                                alt="OtherImg"
                                            />
                                            <h4>Others</h4>
                                        </li>
                                        <li>
                                            <button className="btnplatformIntrest" onClick={() => funPlatforms()} >Platforms</button>
                                        </li>

                                        <li>
                                            <a target="_blank" href="https://payment.moneysukh.com:9002/FundTransfer.aspx" onClick={()=>Backoffice("https://payment.moneysukh.com:9002/FundTransfer.aspx","Fund Transfer")}>Payment Gateway</a>
                                        </li>

                                        <li>
                                            <a href="https://www.nseindia.com/resources/exchange-communication-holidays" target="_blank">Market Holidays </a>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <img
                                                className="img-fluid"
                                                src={brokcal}
                                                alt="UtilitiImg"
                                            />
                                            <h4>Calculator</h4>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeBrokarage}>Brokerage Calculator</a>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeEmi}>EMI Calculator</a>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeFd}>FD Calculator</a>
                                        </li>
                                        <li>
                                            <a onClick={routeChangeElss}>ELSS Calculator</a>
                                        </li>


                                    </ul>
                                </div>
                                <div className="main-navbar-beta">
                                    <ul>
                                        <li>
                                            <a href="/PartnerUs">
                                                <img src={PartnetImg} alt="PartnetImg" />
                                                <strong>Partner with us</strong>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://online.moneysukh.com/" target="_blank">
                                                <img src={kambalalogin} alt="ReferImg" />
                                                <strong>Login<sup>new</sup></strong>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://backoffice.moneysukh.com:8080/capexweb/capexweb/" onClick={()=>Backoffice("https://backoffice.moneysukh.com:8080/capexweb/capexweb","Back Office")}>
                                                <img src={backofficeImg} alt="backoffice" />
                                                <strong>Back office Login</strong>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default MobileNav;
